import React from 'react';

function WorkItemCard({ item, parentItem, onClick, onParentClick, onShowRelatedItems, onDragStart, draggable = true }) {
  const formatDate = (timestamp) => {
    if (!timestamp) return 'No updates yet';
    const date = timestamp.toDate?.() || new Date(timestamp);
    return date.toLocaleDateString();
  };

  const getParentColor = (parentType) => {
    if (parentType === 'Epic') return '#28a745';
    if (parentType === 'Initiative') return '#dc3545';
    return '#667eea';
  };

  const handleParentClick = (e) => {
    e.stopPropagation();
    if (onParentClick && parentItem) {
      onParentClick(parentItem);
    }
  };

  return (
    <div 
      className={`work-item-card ${item.type.toLowerCase()}`}
      onClick={onClick}
      draggable={draggable}
      onDragStart={onDragStart}
    >
      <div className="card-header">
        <h3 className="card-title">{item.title}</h3>
        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
          {onShowRelatedItems && (
            <button
              className="hierarchy-button"
              onClick={(e) => {
                e.stopPropagation();
                onShowRelatedItems(item);
              }}
              aria-label="Show related items in hierarchy"
              title="Show related items in hierarchy"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="16" y="16" width="6" height="6" rx="1"></rect>
                <rect x="2" y="16" width="6" height="6" rx="1"></rect>
                <rect x="9" y="2" width="6" height="6" rx="1"></rect>
                <path d="M12 8v3"></path>
                <path d="M12 11l-3 3"></path>
                <path d="M12 11l3 3"></path>
              </svg>
            </button>
          )}
          {parentItem && (
            <div className="parent-indicator-wrapper">
              <button
                className="parent-indicator"
                onClick={handleParentClick}
                aria-label={`Parent: ${parentItem.type} - ${parentItem.title}`}
                style={{
                  backgroundColor: getParentColor(parentItem.type)
                }}
              />
              <div className="parent-tooltip">
                {parentItem.type}: {parentItem.title}
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="card-tags">
        {item.division && <span className="tag">{item.division}</span>}
        {item.tags && item.tags.map((tag, index) => (
          <span key={index} className="tag tag-badge">{tag}</span>
        ))}
      </div>

      <div className="card-footer">
        Last updated: {formatDate(item.lastNoteDate)}
      </div>
    </div>
  );
}

export default WorkItemCard;
